import type { AgentResponse, ProPilotFrame } from "../types";

export type NormalizedIncomingFrame =
  | { kind: "message"; content: AgentResponse }
  | { kind: "done" }
  | { kind: "error"; reason: string }
  | { kind: "ignore" };

export const normalizeIncomingFrame = (frame: ProPilotFrame): NormalizedIncomingFrame => {
  if (frame.type === "done") {
    return { kind: "done" };
  }

  if (typeof frame.error === "string" && frame.error.length > 0) {
    return { kind: "error", reason: frame.error };
  }

  if (typeof frame.text === "string" && frame.text.length > 0) {
    return {
      kind: "message",
      content: {
        type: "generic",
        text: frame.text,
        allowFreeText: true,
        complete: true
      }
    };
  }

  return { kind: "ignore" };
};
